<div *ngIf="!hideDate" [class.three-columns]="!hideAddToCalendar" class="icon-text-container">
  <div class="icon">
    <img alt="date" height="24" ngSrc="assets/images/icon-date.svg" width="24">
  </div>
  <div class="text">
    <span class="semiBold">{{ appointment.date | date : 'fullDate' : appointment.timezone : locale }}</span><br>
    <span>{{ 'APPOI.PROPOSAL.ARRIVAL_TECHNICIAN' | translate }}</span><span>:&nbsp;</span>
    <span
      [translateParams]="{
            beginTimeFrom: appointment.beginTimeFrom | date : 'shortTime' : appointment.timezone : locale,
            beginTimeEnd: appointment.beginTimeTo | date : 'shortTime' : appointment.timezone : locale,
          }"
      [translate]="'APPOI.LABEL_ARRIVAL_TECHNICIAN.DISPLAY_TYPE_FROM_TILL'"
      class="semiBold text-nowrap"
    ></span>
    <ng-container *ngIf="showDuration">
      <br>
      <span>{{ 'APPOI.PROPOSAL.DURATION' | translate }}</span>:&nbsp;<span
      class="semiBold">{{ appointment.duration }}</span>
    </ng-container>
  </div>
  <div *ngIf="!hideAddToCalendar" class="actions">
    <button (throttledClick)="addToCalendar()"
            [gtmEventName]="'import_to_calendar'"
            [throttleTime]="5000"
            appPreventDoubleClick
            class="vi-button vi-button-xs"
            mat-flat-button>
      <mat-icon svgIcon="calendar"></mat-icon>
      {{ 'APPOI.BUTTON.ADD_TO_CALENDAR' | translate }}
    </button>
  </div>
</div>
<div *ngIf="!hideInfo" class="icon-text-container">
  <div class="icon">
    <img alt="info" height="24" ngSrc="assets/images/icon-info.svg" width="24">
  </div>
  <div class="text">
    <span class="semiBold">{{ 'APPOI.PROPOSAL.INFO_TEXT_1' | translate }}</span><br>
    <span>{{ 'APPOI.PROPOSAL.INFO_TEXT_2' | translate }}</span>
  </div>
</div>
<div *ngIf="!hideInstallation" class="icon-text-container">
  <div class="icon">
    <img alt="boiler" height="24" ngSrc="assets/images/icon-boiler.svg" width="24">
  </div>
  <div class="text">
    <span class="semiBold">{{ 'APPOI.SERVICE_CALL_TYPE.' + appointment.serviceCallType | translate }}</span><br>
    <span>{{ 'APPOI.PROPOSAL.SERVICE_CALL_ID' | translate }}</span>: <span>{{ appointment.orderNumber }}</span><br>
    <ng-container *ngIf="appointment.serialDescription"><span>{{ appointment.serialDescription }}</span><br>
    </ng-container>
  </div>
</div>
<div *ngIf="!hideLocation" class="icon-text-container">
  <div class="icon">
    <img alt="location" height="24" ngSrc="assets/images/icon-location.svg" width="24">
  </div>
  <div class="text">
    <span>{{ appointment.address.addressLine1 }}</span><br>
    <span>{{ appointment.address.addressLine2 }}</span><br>
    <span>{{ appointment.address.addressLine3 }}</span>
  </div>
</div>
